import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Facilitator } from '@interfaces';
import { AppService } from '../../../../../../services';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, app: AppService): GridSetup<Facilitator> {

	return {
		rowName: { singular: 'Facilitator', plural: 'Facilitators' },
		getRowKey: row => '' + row.facilitatorId,
		stateKey: 'accelerator-facilitators-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util, app),
	}
}
